import React from 'react';
import { useLoading } from './LoadingContext';
import { FiRefreshCw } from 'react-icons/fi';

const GlobalLoadingSpinner = () => {
  const { isLoading, loadingMessage } = useLoading();

  if (!isLoading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999, // Höchster z-index um über allem zu erscheinen
        backdropFilter: 'blur(2px)'
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '32px',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
          minWidth: '200px',
          textAlign: 'center'
        }}
      >
        <FiRefreshCw 
          size={32} 
          style={{
            animation: 'spin 1s linear infinite',
            color: '#007bff'
          }}
        />
        <div
          style={{
            fontSize: '16px',
            fontWeight: '500',
            color: '#495057'
          }}
        >
          {loadingMessage}
        </div>
      </div>
    </div>
  );
};

export default GlobalLoadingSpinner;